var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-navigation"},_vm._l((_vm.items),function(item){return _c('NuxtLink',{key:item.to,staticClass:"list-navigation__item",class:{
      'nuxt-link-exact-active': item.active,
    },attrs:{"to":item.to,"event":_vm.loading ? '' : 'click'}},[_vm._v(_vm._s(item.label))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }